import { StatusBadge } from 'common/components/StatusBadge/StatusBadge.tsx';
import { PROVISIONING_STATUS_LABEL } from '@/activityLog/bulkProvisioning/constants/provisioningStatus.ts';

import LargeCheckIcon from 'assets/images/BulkStatus/LargeCheck.svg';
import LargeXIcon from 'assets/images/BulkStatus/LargeX.svg';
import PendingIcon from 'assets/images/BulkStatus/Pending.svg';
import { pxToRem } from 'common/utils/fonts.ts';

export const SuccessBadge = () => {
  return (
    <StatusBadge
      status={'success'}
      type={'filled'}
      icon={<LargeCheckIcon width={pxToRem(24)} height={pxToRem(24)} />}
      label={PROVISIONING_STATUS_LABEL.PROCESSING_SUCCEED}
    />
  );
};

export const DataExtractionFailedBadge = () => {
  return (
    <StatusBadge
      status={'error'}
      type={'filled'}
      icon={<LargeXIcon width={pxToRem(24)} height={pxToRem(24)} />}
      label={PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_FAILED}
    />
  );
};

export const ProcessingFailedBadge = () => {
  return (
    <StatusBadge
      status={'error'}
      type={'filled'}
      icon={<LargeXIcon width={pxToRem(24)} height={pxToRem(24)} />}
      label={PROVISIONING_STATUS_LABEL.PROCESSING_FAILED}
    />
  );
};

export const ProcessingInProgressBadge = () => {
  return (
    <StatusBadge
      status={'pending'}
      type={'filled'}
      icon={<PendingIcon width={pxToRem(24)} height={pxToRem(24)} />}
      label={PROVISIONING_STATUS_LABEL.PROCESSING_IN_PROGRESS}
    />
  );
};

export const DataExtractionInProgressBadge = () => {
  return (
    <StatusBadge
      status={'pending'}
      type={'filled'}
      icon={<PendingIcon width={pxToRem(24)} height={pxToRem(24)} />}
      label={PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_IN_PROGRESS}
    />
  );
};

export const DataExtractionPendingBadge = () => {
  return (
    <StatusBadge
      status={'pending'}
      type={'filled'}
      icon={<PendingIcon width={pxToRem(24)} height={pxToRem(24)} />}
      label={PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_PENDING}
    />
  );
};

export const UnknownBadge = () => {
  return <StatusBadge status={'unknown'} type={'filled'} />;
};
